<div class="pca">

  <!-- Header -->
  <div class="pca-header">
    <img src="./assets/building-service-engineer-thumbnail.png" alt="" class="pca-header-img" />
    <div class="pca-header-text">
      <h2>Add Contractors</h2>
      <p *ngIf="project?.name">to <strong>{{ project.name }}</strong></p>
    </div>
    <button type="button" class="pca-close" (click)="dialogRef.close()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Search -->
  <div class="pca-toolbar">
    <div class="pca-search">
      <mat-icon>search</mat-icon>
      <input type="text" [(ngModel)]="searchTerm" placeholder="Search by name, trade, phone or email" aria-label="Search contractors" />
      <button type="button" *ngIf="searchTerm" (click)="searchTerm = ''" aria-label="Clear search"><mat-icon>close</mat-icon></button>
    </div>
    <span class="pca-count">{{ filteredContractors.length }} of {{ contractors.length }}</span>
  </div>

  <!-- List -->
  <div class="pca-list">

    <div *ngIf="loading" class="pca-empty">Loading contractors…</div>

    <div *ngIf="!loading && filteredContractors.length === 0" class="pca-empty">
      <mat-icon>person_search</mat-icon>
      <span>{{ contractors.length ? 'No contractors match your search.' : 'No contractors yet.' }}</span>
    </div>

    <div class="pca-row" *ngFor="let c of filteredContractors" [class.is-added]="isOnProject(c)">
      <div class="pca-avatar">
        <img *ngIf="c.imageContent; else initialsTpl" [src]="c.imageContent" [alt]="c.name" />
        <ng-template #initialsTpl>{{ initials(c.name) }}</ng-template>
      </div>

      <div class="pca-main">
        <div class="pca-name">{{ c.name }}</div>
        <div class="pca-sub" *ngIf="c.jobTitle">{{ c.jobTitle }}</div>
      </div>

      <div class="pca-contact">
        <a *ngIf="c.cellPhone" href="tel:{{ c.cellPhone }}" class="pca-contact-item">
          <mat-icon>phone</mat-icon>{{ c.cellPhone | phoneFilter }}
        </a>
        <a *ngIf="c.email" href="mailto:{{ c.email }}" class="pca-contact-item pca-email">
          <mat-icon>mail</mat-icon>{{ c.email }}
        </a>
      </div>

      <div class="pca-rate" *ngIf="c.hourlyWage">{{ c.hourlyWage | currency }}<span>/hr</span></div>

      <button type="button" class="pca-add" *ngIf="!isOnProject(c); else addedTpl"
              [disabled]="addingName === c.name" (click)="addContractorToProjectContractors(c)">
        <mat-icon>{{ addingName === c.name ? 'hourglass_empty' : 'add' }}</mat-icon>
        <span>Add</span>
      </button>
      <ng-template #addedTpl>
        <span class="pca-added"><mat-icon>check_circle</mat-icon><span>Added</span></span>
      </ng-template>
    </div>
  </div>

  <!-- Footer -->
  <div class="pca-footer">
    <button type="button" class="pca-done" (click)="dialogRef.close()">Done</button>
  </div>
</div>
